import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { Toaster } from '../ui/toaster';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 min-w-0 overflow-x-hidden">{children}</main>
      <Footer />
      <Toaster />
    </div>
  );
};

export default Layout;
